import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const tiposManutencao = [
  { value: 'oleo', label: '🛢️ Troca de Óleo', cor: '#F59E0B' },
  { value: 'pastilha', label: '🔧 Pastilha de Freio', cor: '#E24B4A' },
  { value: 'disco', label: '⚙️ Disco de Freio', cor: '#E24B4A' },
  { value: 'pneu', label: '🔄 Pneu', cor: '#1D9E75' },
  { value: 'revisao', label: '🔍 Revisão Geral', cor: '#378ADD' },
  { value: 'filtro_ar', label: '💨 Filtro de Ar', cor: '#7C3AED' },
  { value: 'filtro_combustivel', label: '⛽ Filtro de Combustível', cor: '#7C3AED' },
  { value: 'correia', label: '⚡ Correia Dentada', cor: '#E87B1E' },
  { value: 'bateria', label: '🔋 Bateria', cor: '#666' },
  { value: 'velas', label: '✨ Velas de Ignição', cor: '#F59E0B' },
  { value: 'alinhamento', label: '📐 Alinhamento/Balanceamento', cor: '#1D9E75' },
  { value: 'suspensao', label: '🚗 Suspensão', cor: '#378ADD' },
  { value: 'outros', label: '🔩 Outros', cor: '#666' },
];

function getTipo(value) {
  return tiposManutencao.find(t => t.value === value) || { label: value, cor: '#666' };
}

function proximaStatus(m) {
  const hoje = new Date();
  if (m.proxima_data) {
    const diff = (new Date(m.proxima_data) - hoje) / 1000 / 60 / 60 / 24;
    if (diff < 0) return { texto: 'Vencida', cor: '#A32D2D', bg: '#FCEBEB' };
    if (diff <= 15) return { texto: `Vence em ${Math.ceil(diff)} dias`, cor: '#633806', bg: '#FAEEDA' };
  }
  return null;
}

function exportarPDF(manutencoes, targetNome) {
  const conteudo = `
    <html>
    <head>
      <meta charset="utf-8">
      <title>Historico de Manutencao</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }
        h1 { color: #1D9E75; font-size: 18px; margin-bottom: 4px; }
        p { color: #999; font-size: 11px; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #1D9E75; color: white; padding: 8px 10px; text-align: left; font-size: 11px; }
        td { padding: 8px 10px; border-bottom: 1px solid #eee; font-size: 11px; }
        tr:nth-child(even) td { background: #f9f9f9; }
        .footer { margin-top: 20px; text-align: center; color: #999; font-size: 10px; }
      </style>
    </head>
    <body>
      <h1>Historico de Manutencao</h1>
      <p>Gerado em ${new Date().toLocaleString('pt-BR')} - Desenvolvido por Digital Mais BR</p>
      <table>
        <thead>
          <tr>
            <th>Tipo</th><th>Data</th><th>KM</th><th>Valor</th>
            <th>Oficina</th><th>Proxima KM</th><th>Proxima Data</th><th>Observacoes</th>
          </tr>
        </thead>
        <tbody>
          ${manutencoes.map(m => `
            <tr>
              <td>${getTipo(m.tipo).label}</td>
              <td>${new Date(m.data_servico).toLocaleDateString('pt-BR')}</td>
              <td>${m.km_atual ? parseInt(m.km_atual).toLocaleString('pt-BR') + ' km' : '-'}</td>
              <td>${m.valor ? 'R$ ' + parseFloat(m.valor).toFixed(2).replace('.', ',') : '-'}</td>
              <td>${m.oficina || '-'}</td>
              <td>${m.proxima_km ? parseInt(m.proxima_km).toLocaleString('pt-BR') + ' km' : '-'}</td>
              <td>${m.proxima_data ? new Date(m.proxima_data).toLocaleDateString('pt-BR') : '-'}</td>
              <td>${m.observacoes || '-'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <div class="footer">Desenvolvido por Digital Mais BR - digitalmaisbr.com.br</div>
    </body>
    </html>
  `;
  const janela = window.open('', '_blank');
  janela.document.write(conteudo);
  janela.document.close();
  janela.focus();
  setTimeout(() => janela.print(), 500);
}

function Manutencoes() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [manutencoes, setManutencoes] = useState([]);
  const [targets, setTargets] = useState([]);
  const [targetFiltro, setTargetFiltro] = useState('');
  const [tipoFiltro, setTipoFiltro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [editando, setEditando] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [form, setForm] = useState({
    target_id: '', tipo: 'oleo', data_servico: new Date().toISOString().split('T')[0],
    km_atual: '', valor: '', oficina: '', observacoes: '', proxima_km: '', proxima_data: ''
  });

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarDados(); }, []);

  const carregarDados = async () => {
    try {
      const [manutRes, targetsRes] = await Promise.all([
        axios.get(`${API}/manutencoes`, { headers }),
        axios.get(`${API}/targets`, { headers }),
      ]);
      setManutencoes(manutRes.data);
      setTargets(targetsRes.data);
    } catch (err) { console.error(err); }
  };

  const abrirNovo = () => {
    setEditando(null);
    setForm({
      target_id: targetFiltro || '', tipo: 'oleo',
      data_servico: new Date().toISOString().split('T')[0],
      km_atual: '', valor: '', oficina: '', observacoes: '', proxima_km: '', proxima_data: ''
    });
    setModalAberto(true);
  };

  const abrirEditar = (m) => {
    setEditando(m);
    setForm({
      target_id: m.target_id,
      tipo: m.tipo,
      data_servico: m.data_servico ? m.data_servico.split('T')[0] : '',
      km_atual: m.km_atual || '',
      valor: m.valor || '',
      oficina: m.oficina || '',
      observacoes: m.observacoes || '',
      proxima_km: m.proxima_km || '',
      proxima_data: m.proxima_data ? m.proxima_data.split('T')[0] : '',
    });
    setModalAberto(true);
  };

  const salvar = async () => {
    if (!form.target_id || !form.tipo || !form.data_servico) {
      alert('Veiculo, tipo e data sao obrigatorios!');
      return;
    }
    setSalvando(true);
    try {
      if (editando) {
        await axios.put(`${API}/manutencoes/${editando.id}`, form, { headers });
      } else {
        await axios.post(`${API}/manutencoes`, form, { headers });
      }
      setModalAberto(false);
      carregarDados();
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao salvar'); }
    setSalvando(false);
  };

  const deletar = async (id) => {
    if (!window.confirm('Deseja remover este registro?')) return;
    await axios.delete(`${API}/manutencoes/${id}`, { headers });
    carregarDados();
  };

  const manutencoesFiltradas = manutencoes.filter(m => {
    if (targetFiltro && m.target_id !== parseInt(targetFiltro)) return false;
    if (tipoFiltro && m.tipo !== tipoFiltro) return false;
    return true;
  });

  const targetSelecionado = targets.find(t => t.id === parseInt(targetFiltro));
  const vencidas = manutencoes.filter(m => proximaStatus(m) && proximaStatus(m).texto === 'Vencida').length;
  const proximas = manutencoes.filter(m => proximaStatus(m) && proximaStatus(m).texto !== 'Vencida').length;

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>{sidebarAberta ? '✕' : '☰'}</button>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>🔧 Manutencao</span>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => exportarPDF(manutencoesFiltradas, targetSelecionado ? targetSelecionado.identificador : null)}
            style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
            Exportar PDF
          </button>
          <button onClick={abrirNovo}
            style={{ background: 'white', color: '#1D9E75', border: 'none', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '700', fontSize: '14px' }}>
            + Novo Registro
          </button>
        </div>
      </div>

      <div style={{ marginTop: '60px', padding: '24px' }}>

        {(vencidas > 0 || proximas > 0) && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px', marginBottom: '20px' }}>
            {vencidas > 0 && (
              <div style={{ background: '#FCEBEB', borderRadius: '12px', padding: '16px', borderLeft: '4px solid #A32D2D' }}>
                <div style={{ fontSize: '24px', fontWeight: '700', color: '#A32D2D' }}>{vencidas}</div>
                <div style={{ fontSize: '13px', color: '#A32D2D', fontWeight: '600' }}>Manutencao(oes) vencida(s)</div>
              </div>
            )}
            {proximas > 0 && (
              <div style={{ background: '#FAEEDA', borderRadius: '12px', padding: '16px', borderLeft: '4px solid #633806' }}>
                <div style={{ fontSize: '24px', fontWeight: '700', color: '#633806' }}>{proximas}</div>
                <div style={{ fontSize: '13px', color: '#633806', fontWeight: '600' }}>Manutencao(oes) proxima(s)</div>
              </div>
            )}
          </div>
        )}

        <div style={{ background: 'white', borderRadius: '12px', padding: '16px', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
          <select value={targetFiltro} onChange={e => setTargetFiltro(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', background: 'white', minWidth: '200px' }}>
            <option value="">Todos os veiculos</option>
            {targets.map(t => <option key={t.id} value={t.id}>{t.icone} {t.identificador} - {t.nome}</option>)}
          </select>
          <select value={tipoFiltro} onChange={e => setTipoFiltro(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', background: 'white', minWidth: '200px' }}>
            <option value="">Todos os tipos</option>
            {tiposManutencao.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
          <span style={{ fontSize: '13px', color: '#999', marginLeft: 'auto' }}>
            {manutencoesFiltradas.length} registro{manutencoesFiltradas.length !== 1 ? 's' : ''}
          </span>
        </div>

        {manutencoesFiltradas.length === 0 ? (
          <div style={{ background: 'white', borderRadius: '12px', padding: '48px', textAlign: 'center', color: '#999', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔧</div>
            <div style={{ fontSize: '16px', fontWeight: '500' }}>Nenhum registro de manutencao</div>
            <div style={{ fontSize: '13px', marginTop: '8px' }}>Clique em "+ Novo Registro" para comecar</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {manutencoesFiltradas.map((m, i) => {
              const tipo = getTipo(m.tipo);
              const status = proximaStatus(m);
              return (
                <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderLeft: `4px solid ${tipo.cor}`, display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <div style={{ fontSize: '28px', marginTop: '2px' }}>{tipo.label.split(' ')[0]}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '6px' }}>
                      <span style={{ fontSize: '14px', fontWeight: '700', color: '#333' }}>{tipo.label}</span>
                      <span style={{ background: '#f0f0f0', color: '#666', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '500' }}>
                        {m.icone} {m.identificador} - {m.target_nome}
                      </span>
                      {status && (
                        <span style={{ background: status.bg, color: status.cor, padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600' }}>
                          {status.texto}
                        </span>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', fontSize: '12px', color: '#555', marginBottom: '4px' }}>
                      <span>{new Date(m.data_servico).toLocaleDateString('pt-BR')}</span>
                      {m.km_atual && <span>{parseInt(m.km_atual).toLocaleString('pt-BR')} km</span>}
                      {m.valor && <span>R$ {parseFloat(m.valor).toFixed(2).replace('.', ',')}</span>}
                      {m.oficina && <span>{m.oficina}</span>}
                    </div>
                    {(m.proxima_km || m.proxima_data) && (
                      <div style={{ fontSize: '11px', color: '#999', marginBottom: '4px' }}>
                        Proxima troca:
                        {m.proxima_km && ` ${parseInt(m.proxima_km).toLocaleString('pt-BR')} km`}
                        {m.proxima_km && m.proxima_data && ' ou'}
                        {m.proxima_data && ` ${new Date(m.proxima_data).toLocaleDateString('pt-BR')}`}
                      </div>
                    )}
                    {m.observacoes && <div style={{ fontSize: '12px', color: '#777', fontStyle: 'italic' }}>{m.observacoes}</div>}
                    <div style={{ fontSize: '11px', color: '#bbb', marginTop: '4px' }}>Registrado por {m.usuario_nome || 'sistema'}</div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
                    <button onClick={() => abrirEditar(m)}
                      style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '6px', padding: '6px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
                      Editar
                    </button>
                    <button onClick={() => deletar(m.id)}
                      style={{ background: '#FCEBEB', color: '#A32D2D', border: 'none', borderRadius: '6px', padding: '6px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
                      Remover
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {modalAberto && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '600px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
              <h2 style={{ margin: 0, fontSize: '18px' }}>🔧 {editando ? 'Editar Registro' : 'Novo Registro de Manutencao'}</h2>
              <button onClick={() => setModalAberto(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>x</button>
            </div>
            <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '14px' }}>

              <div>
                <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Veiculo *</label>
                <select value={form.target_id} onChange={e => setForm(p => ({ ...p, target_id: e.target.value }))}
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', background: 'white' }}>
                  <option value="">Selecione o veiculo</option>
                  {targets.map(t => <option key={t.id} value={t.id}>{t.icone} {t.identificador} - {t.nome}</option>)}
                </select>
              </div>

              <div>
                <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '6px' }}>Tipo de Manutencao *</label>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px' }}>
                  {tiposManutencao.map(t => (
                    <div key={t.value} onClick={() => setForm(p => ({ ...p, tipo: t.value }))}
                      style={{ padding: '8px 10px', borderRadius: '8px', border: `2px solid ${form.tipo === t.value ? t.cor : '#eee'}`, cursor: 'pointer', background: form.tipo === t.value ? t.cor + '20' : 'white', fontSize: '12px', fontWeight: form.tipo === t.value ? '600' : '400', color: form.tipo === t.value ? t.cor : '#555', transition: 'all .15s' }}>
                      {t.label}
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Data do Servico *</label>
                  <input type="date" value={form.data_servico} onChange={e => setForm(p => ({ ...p, data_servico: e.target.value }))}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>KM Atual</label>
                  <input type="number" placeholder="Ex: 45000" value={form.km_atual} onChange={e => setForm(p => ({ ...p, km_atual: e.target.value }))}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Valor (R$)</label>
                  <input type="number" step="0.01" placeholder="Ex: 150.00" value={form.valor} onChange={e => setForm(p => ({ ...p, valor: e.target.value }))}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Oficina / Local</label>
                  <input type="text" placeholder="Nome da oficina" value={form.oficina} onChange={e => setForm(p => ({ ...p, oficina: e.target.value }))}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
              </div>

              <div style={{ background: '#f8f8f8', borderRadius: '10px', padding: '14px' }}>
                <div style={{ fontSize: '12px', color: '#666', fontWeight: '600', marginBottom: '10px' }}>PROXIMA TROCA (opcional)</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '4px' }}>Proxima KM</label>
                    <input type="number" placeholder="Ex: 50000" value={form.proxima_km} onChange={e => setForm(p => ({ ...p, proxima_km: e.target.value }))}
                      style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', background: 'white' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '4px' }}>Proxima Data</label>
                    <input type="date" value={form.proxima_data} onChange={e => setForm(p => ({ ...p, proxima_data: e.target.value }))}
                      style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', background: 'white' }} />
                  </div>
                </div>
              </div>

              <div>
                <label style={{ fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Observacoes</label>
                <textarea value={form.observacoes} onChange={e => setForm(p => ({ ...p, observacoes: e.target.value }))}
                  placeholder="Detalhes adicionais sobre o servico..." rows={3}
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }} />
              </div>

            </div>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '12px', position: 'sticky', bottom: 0, background: 'white' }}>
              <button onClick={() => setModalAberto(false)} style={{ background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{ background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 24px', cursor: salvando ? 'not-allowed' : 'pointer', fontWeight: '600' }}>
                {salvando ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Manutencoes;